import { createAction, props } from '@ngrx/store';
import { TreeNode } from 'primeng/api';

export const toggleNode = createAction('ProjectLocationToggleNode', props<{ key: string; expanded: boolean }>());

export const selectNode = createAction('ProjectLocationSelectNode', props<{ key: string }>());

export const loadProjectLocationSuccess = createAction('ProjectLocationLoadSuccess', props<{ projectLocations: TreeNode[] }>());

export const refreshTree = createAction('ProjectLocationRefresh');

